import * as actionTypes from '../actions/actionTypes';

const initialState = {
    coupons: null,
    error: false,
    loading: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_COUPONS:
            return {
                ...state,
                coupons: action.coupons,
                error: false,
                loading: false
            };
        case actionTypes.FETCH_COUPONS_FAILED:
            return {
                ...state,
                error: true,
                loading: false
            };
        case actionTypes.FETCH_COUPONS_STARTING:
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
};

export default reducer;